import React from 'react'

export const PartnerBalanceIndicator = ({fill}) => {
  return (
    <svg stroke='currentColor' fill={fill || `currentColor`} strokeWidth='0' height='1em' width='1em' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'>
      <g fill={fill || `currentColor`} fillRule='evenodd'><path d='M16 0v16L0 0zM14 16h-1.454L0 3.454V2zM11 16H9.557L0 6.443V5zM8 16H6.575L0 9.425V8zM5 16H3.61L0 12.39V11l5 5zM2 16H0v-2z' /></g>
    </svg>
  )
}
